import { v4 as uuidv4 } from 'uuid';

export function ProductPriceSavings(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductPriceSavings',
		componentId: uuidv4(),
		props: Object.assign(
			{
				markers: [],
				message: '',
				blockClass: 'product-price-savings',
			},
			props,
		),
		childrenComponents,
	};
}
